module.exports = __webpack_public_path__ + "public/images/slider/speaker-1-1024.d3b3a0dad98452b51e89909ffc1849fb.png";